var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeNiralakkaBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124 124",
    width: 124,
    height: 124,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e88d83;stroke: #e88d83;stroke-miterlimit:10;stroke-width: 5 } \n\t\t.s1 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m49.33 87.84l-0.26 8.31-15.53-0.43c0.21-13.1 0.84-30.86 0.84-42.49 0-12.23-0.38-32.81-0.62-47.72l15.66-0.51-0.26 8.28c-3.16-0.16-8.5-0.28-9.9-0.28-0.16 12.42 0.07 30.51 0.07 40.19 0 7.27-0.45 22.63-0.29 35.31 1.29-0.01 6.85-0.24 10.29-0.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m66.79 40.64l0.36-8.23 21.69 0.42c-0.28 13-1.15 30.53-1.15 42 0 12.08 0.6 32.46 0.9 47.2l-21.88 0.52 0.36-8.19c4.42 0.15 11.88 0.23 13.83 0.23 0.22-12.29-0.12-30.19-0.12-39.76 0-7.19 0.61-22.39 0.38-34.94-1.8 0.11-9.57 0.33-14.37 0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m77.11 2l-6.86 18h-9l8.75-18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeNiralakkaBlanc);
export default __webpack_public_path__ + "static/media/Icone_Niralakka_blanc.87727be08c8a59c5e318d5f256f3c63c.svg";
export { ForwardRef as ReactComponent };